import { Component, HostListener } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';

@Component({
  selector: 'app-theme',
  templateUrl: './theme.component.html',
  styleUrls: ['./theme.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100%)' }),
        animate('1s ease', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate(
          '1s ease',
          style({ opacity: 0, transform: 'translateX(100%)' })
        ),
      ]),
    ]),
    trigger('slideDownUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10%)' }),
        animate('1s ease', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('1s ease', style({ opacity: 0, transform: 'translateY(0%)' })),
      ]),
    ]),
  ],
})
export class ThemeComponent {
  constructor(private themeService: ThemeService) {}

  primaryDemo: string = '';
  secondaryDemo: string = '';
  tertiaryDemo: string = '';
  quaternaryDemo: string = '';
  changeColor: boolean = false;

  get stateName() {
    return this.changeColor ? 'left' : 'right';
  }

  ngOnInit() {
    this.themeService.getPrimaryColor().subscribe((color) => {
      this.primaryDemo = color;
    });
    this.themeService.getSecondaryColor().subscribe((color) => {
      this.secondaryDemo = color;
    });
    this.themeService.getTertiaryColor().subscribe((color) => {
      this.tertiaryDemo = color;
    });
    this.themeService.getQuaternaryColor().subscribe((color) => {
      this.quaternaryDemo = color;
    });
  }

  onColorChangePrimary(event: any) {
    const selectedColor = event.target.value;
    this.primaryDemo = selectedColor;
    document.body.style.setProperty('--primary', this.primaryDemo);
  }

  onColorChangeSecondary(event: any) {
    const selectedColor = event.target.value;
    this.secondaryDemo = selectedColor;
    document.body.style.setProperty('--secondary', this.secondaryDemo);
  }

  onColorChangeTertiary(event: any) {
    const selectedColor = event.target.value;
    this.tertiaryDemo = selectedColor;
    document.body.style.setProperty('--tertiary', this.tertiaryDemo);
  }

  onColorChangeQuaternary(event: any) {
    const selectedColor = event.target.value;
    this.quaternaryDemo = selectedColor;
    document.body.style.setProperty('--quaternary', this.quaternaryDemo);
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (this.changeColor) {
      this.changeColor = false;
      console.log('clicked outside');
    }
  }
}
